import React from 'react';

const VirtualTourPage = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">Virtual Tour</h1>
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <div className="bg-gray-200 aspect-video rounded-lg flex items-center justify-center mb-6">
              <p className="text-gray-500">Virtual Tour Interface Placeholder</p>
            </div>
            <h2 className="text-2xl font-semibold mb-4">Experience Our Gallery Virtually</h2>
            <p className="text-gray-600 mb-6">
              Take an immersive virtual tour of our gallery spaces and explore 
              our collections from the comfort of your home.
            </p>
            <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors">
              Start Virtual Tour
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VirtualTourPage;